<div class="splash-screen" [class.hidden]="isHidden">
  <div class="splash-content">
    <div class="lottie-container" #lottieContainer></div>
  </div>
</div>